import { getSentryContext } from 'contexts'

const { useSentry, SentryProvider } = getSentryContext()
export { SentryProvider, useSentry }
